export default __webpack_public_path__ + "static/api3-850499a35c87c5d1104afcee6f964d03.svg";